/**
 * Horizontal creative section: Senders (left) | Campaign texts (right).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { ApplyRuleBasedSendersSection } from './senders';
import { ApplyRuleBasedTextsSection } from './ApplyRuleBasedTextsSection';

export interface ApplyRuleBasedCreativeSectionProps {
  smsTexts: string[];
  senderNames: string[];
  selectedTexts: string[];
  selectedSenders: string[];
  onToggleText: (text: string) => void;
  onToggleSender: (sender: string) => void;
  onSelectAllTexts: () => void;
  onSelectAllSenders: () => void;
  onTextsChange: (texts: string[]) => void;
  onSendersChange: (senders: string[]) => void;
  onPerDropTextsChange: (batches: string[][] | null) => void;
  onPerDropSendersChange: (batches: string[][] | null) => void;
  onAiGeneratingChange?: (isGenerating: boolean) => void;
  countryKey: string;
  dropCount?: number;
  dropLabels?: Array<{ id: string; label: string }>;
  tagColors?: Record<string, string>;
  isBusy: boolean;
}

export const ApplyRuleBasedCreativeSection: FC<ApplyRuleBasedCreativeSectionProps> = (
  props,
) => {
  return (
    <div className="grid min-w-0 grid-cols-1 gap-4 sm:grid-cols-2">
      <div className="min-w-0 rounded-lg border border-border/80 bg-muted/5 p-3">
        <ApplyRuleBasedSendersSection
          senderNames={props.senderNames}
          selectedSenders={props.selectedSenders}
          onToggleSender={props.onToggleSender}
          onSelectAll={props.onSelectAllSenders}
          onSendersChange={props.onSendersChange}
          onPerDropBatchesChange={props.onPerDropSendersChange}
          onAiGeneratingChange={props.onAiGeneratingChange}
          countryKey={props.countryKey}
          dropCount={props.dropCount}
          dropLabels={props.dropLabels}
          isBusy={props.isBusy}
        />
      </div>
      <div className="min-w-0 rounded-lg border border-border/80 bg-muted/5 p-3">
        <ApplyRuleBasedTextsSection
          smsTexts={props.smsTexts}
          selectedTexts={props.selectedTexts}
          onToggleText={props.onToggleText}
          onSelectAll={props.onSelectAllTexts}
          onTextsChange={props.onTextsChange}
          onPerDropBatchesChange={props.onPerDropTextsChange}
          onAiGeneratingChange={props.onAiGeneratingChange}
          countryKey={props.countryKey}
          dropCount={props.dropCount}
          dropLabels={props.dropLabels}
          tagColors={props.tagColors}
          isBusy={props.isBusy}
        />
      </div>
    </div>
  );
};
